import React from 'react';
import clsx from 'clsx';

import styles from '../styles.module.scss';
import whitelabelStyles from './Whitelabel.module.scss';
import {Logo} from '../../../assets';
import whitelist from '../../../assets/img/whitelist.png';
import whitelistHover from '../../../assets/img/whitelistHover.png';

export const WhitelabelCard = () => {
  return (
    <div className={whitelabelStyles.whitelabel}>
      <div className={clsx(styles.label, styles.soon)}>
        <div className={clsx(styles.labelInner, styles.soon)}>soon</div>
      </div>
      <h4 className={styles.title}>Whitelabel</h4>
      <p className={styles.subTitle}>
        Customize your bot's name and profile picture to seamlessly integrate it into your unique
        style
      </p>
      <div className={whitelabelStyles.image}>
        <Logo />
      </div>
      <div className={whitelabelStyles.decor}>
        <img src={whitelist} alt="" />
      </div>

      <div className={whitelabelStyles.hover}>
        <img src={whitelistHover} alt="" />
      </div>
    </div>
  );
};
